// types
import { FeatureFlag } from '../@types';

export function isFeatureEnabled(feature: FeatureFlag): boolean {
	return process.env[`REACT_APP_${feature}`] === 'true';
}

export const featureFlags: Record<FeatureFlag, boolean> = {
	ACTIVITIES: isFeatureEnabled('ACTIVITIES'),
	CONTRACT_WORKFLOW: isFeatureEnabled('CONTRACT_WORKFLOW'),
	CRM: isFeatureEnabled('CRM'),
	DIRECT: isFeatureEnabled('DIRECT'),
	FINANCIAL_TRACEABILITY: isFeatureEnabled('FINANCIAL_TRACEABILITY'),
	IFRS: isFeatureEnabled('IFRS_GENERAL') || isFeatureEnabled('IFRS_TRIALS'),
	IFRS_GENERAL: isFeatureEnabled('IFRS_GENERAL'),
	IFRS_TRIALS: isFeatureEnabled('IFRS_TRIALS'),
	LEARNING_HUB: isFeatureEnabled('LEARNING_HUB'),
	LOCAL_CURRENCY: isFeatureEnabled('LOCAL_CURRENCY'),
	REIMBURSEMENT: isFeatureEnabled('REIMBURSEMENT'),
	SPECIAL: isFeatureEnabled('SPECIAL'),
	TRANSACTION_RETRY: isFeatureEnabled('TRANSACTION_RETRY'),
	UTILIZATION: isFeatureEnabled('UTILIZATION'),
};
